export default __webpack_public_path__ + "static/media/ürün_acıklama_resmi.281509ed.png";